/*
 * Copyright (c) 2022 CalAmp Corp. All Rights Reserved
 */
import {useMemo} from 'react';
import {get} from '@ion/core/src/environment/environment';
import {hasRole} from '@ion/core/src/security/helpers';
import {safeJSONParse} from '@ion/core/src/utils/JSONUtils';
import {useAuthenticatedUser} from '../admin/users/useAuthenticatedUser';

/**
 * Determines if the currently authenticated user can access the vbus enable feature
 * when working with Device entities (add/update).
 *
 * Currently, a user must have a role of FW Uploader or Calamp Support.
 */
export const useVbusAccess = (isCalampSupport = false): boolean => {
  const {roles}       = useAuthenticatedUser();
  const userHasAccess = useMemo(() => {
    const vbusAllRoles      = safeJSONParse(get('vbusRoles'));
    const calAmpSuportRole  = [vbusAllRoles[1]];
    const vbusRole          = isCalampSupport ? calAmpSuportRole : vbusAllRoles;
    return hasRole(roles, vbusRole);
  }, [roles]);
  return userHasAccess;
};

export default useVbusAccess;
